<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Productos" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Ark45')"
          subtitle=""
          :ctaText="$t('Acceder')"
          ctaTarget="http://ark45.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-Yate%20mar.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Arkyteck1980')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://arkyteck1980.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-villa-lujo-piscina-espectacular-diseno-contemporaneo-arte-digital-bienes-raices-hogar-casa-propiedad-ge.jpg"
        ></dashboard-banner-tile>
        <!--- 
        <dashboard-banner-tile
          :title="$t('Zammarket')"
          :ctaText="$t('Proximamente')"
          ctaTarget="#"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-concepto-pedido-tienda-compras-linea.jpg"
        ></dashboard-banner-tile>
        -->
      </div>
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Travelerup')"
          :ctaText="$t('Acceder')"
          ctaTarget="http://www.travelerup.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-viaje-avion-avion-viaje.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Inmolook')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://inmolook.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-primer-plano-persona-pensando-comprar-o-vender-casa.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Ecobanka Direct')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://ecobanka.com/negocios/ecobanka-direct-2/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-Ecobanka%20Direct.jpg"
        ></dashboard-banner-tile>
      </div>
      <div class="tile is-ancestor full-width is-vertical height-100">
        <div class="tile is-parent is-4 is-horizontal">
          <dashboard-banner-tile
            :title="$t('Ayudas y Subvenciones')"
            subtitle=""
            :ctaText="$t('Acceder')"
            ctaTarget="Ayudas y Subvenciones"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-pexels-karolina-grabowska-4386152.jpg"
          ></dashboard-banner-tile>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Products',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Products'],
      title: 'Products'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
